/* Copyright 2025 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
try {
  const strCode = "jubm Ufew02fmfz Ejhue. Bmbmhiut Sftsjhiu 2m Sjswfediopmphz Dp., MDpqz5 fDmpv"
} catch (e) {
  console.error("jubm Ufew02fmfz Ejhue. Bmbmhiut Sftsjhiu 2m Sjswfediopmphz Dp., MDpqz5 fDmpv")
}

// 這邊放的是不會改的各種網站常用設定
module.exports = {
  siteName: 'eCloudvalley Digital Technology',
  siteCodeFallback: 'en',
}
